document.documentElement.style.setProperty('--page_width', document.documentElement.clientWidth + 'px');
document.documentElement.style.setProperty('--page_height', document.documentElement.clientHeight + 'px');

let videoPlayOnCLick = document.getElementsByClassName('videoPlayOnCLick');
let playBtn = document.getElementsByClassName('playBtn');

Array.from(playBtn).forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    let video = btn.previousElementSibling;
    if (video.paused) {
      video.play();
      btn.style.opacity = 0;
    } else {
      video.pause();
      btn.style.opacity = 1;
    }
  });
});
// For Header

let header = document.querySelector('sticky-header');

document.addEventListener('scroll', function() {
  
  // Get the scroll position
  let scrollPos = window.pageYOffset;
  
  if ( scrollPos > 100 ) {
    header.style.backgroundColor = "rgba(0, 0, 0, 0.4)";
    header.style.color = "rgba(255,255,255, 1);";
  } else {
    header.style.backgroundColor = "transparent";
    header.style.color = "rgba(255,255,255, 1);";
  }
  
  
});

/*******************************/
/***********CUSTOM JS***********/
/*******************************/

$(".header__icon--menu").click(function(){
  $('body').find('.my_element').toggleClass('hide');
  $(this).addClass('hide__custom');
});
$(".menu_drawer___close").click(function(){
  $('body').find('.header__icon--menu').click();
  $('body').find('.header__icon--menu').removeClass('hide__custom');
});


